export default __webpack_public_path__ + "static/media/createIMG.e6842798.jpg";